import { ContactFieldGroup } from "../types"
import { ContactInput } from "./ContactInput"
import Grid from '@mui/material/Unstable_Grid2'; // Grid version 2


export const ContactForm = (props: {
    contact_info: ContactFieldGroup[]
    OnUpdateContactField: (group_id: string, name: string, value: string) => void
}) => {
    return (
        <Grid container spacing={2}>
            {props.contact_info && props.contact_info.map((contact_info, index) => {
                return (
                    <Grid key={index} xs={6}>
                        {contact_info.fields && contact_info.fields.map((field, findex) => {
                            return (
                                <div key={findex}>
                                    <ContactInput
                                        {...field}
                                        group_id={contact_info.group_id}
                                        onUpdate={props.OnUpdateContactField}
                                    />
                                </div>
                            )
                        })}
                    </Grid>
                )
            })}
        </Grid>
    )
}
